import { usePlayer } from "@/context/PlayerContext";
import { useLang } from "@/context/LangContext";

// Glowing "On Air now" pill. Only shows while the Radio.co station reports it is live; tapping it starts the stream.
export const OnAirBadge = () => {
  const { radio, playLive } = usePlayer();
  const { t } = useLang();
  if (!radio?.online) return null;
  return (
    <button
      type="button"
      data-testid="home-on-air-badge"
      onClick={playLive}
      style={{ background: "#14213D", color: "#FBF8F2" }}
      className="onair-glow mt-8 flex max-w-full items-center gap-3 rounded-full py-2 pl-3 pr-5 text-left transition-transform duration-300 hover:-translate-y-0.5"
    >
      <span className="relative grid h-3 w-3 shrink-0 place-items-center">
        <span className="absolute inset-0 animate-ping rounded-full" style={{ background: "#EF4444", opacity: 0.6 }} />
        <span className="relative h-2.5 w-2.5 rounded-full" style={{ background: "#EF4444", boxShadow: "0 0 10px 2px rgba(239,68,68,0.8)" }} />
      </span>
      <span className="shrink-0 font-mono text-xs font-semibold uppercase tracking-[0.2em]" style={{ color: "#F3D27A" }}>
        {t("onair.now")}
      </span>
      {radio.title && (
        <span data-testid="home-on-air-title" className="min-w-0 truncate font-ui text-sm" style={{ color: "#E6E9EF" }}>
          {radio.title}
          {radio.artist && <span style={{ color: "#B7BFCC" }}> · {radio.artist}</span>}
        </span>
      )}
    </button>
  );
};
